import { http } from 'services';

// Personal - Get biography (Experience + Education)
export function getPersonalBiography(cbSuccess, cbError) {
  http.get(
    'personal/biography',
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Get experience
export function getProfessionalExperience(experienceID, cbSuccess, cbError) {
  http.get(
    `personal/biography/experience/${experienceID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Add experience
export function addProfessionalExperience(payload, cbSuccess, cbError) {
  http.post(
    'personal/biography/experience',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Edit experience
export function editProfessionalExperience(experienceID, payload, cbSuccess, cbError) {
  http.patch(
    `personal/biography/experience/${experienceID}`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}
// Personal - Remove experience
export function removeProfessionalExperience(experienceID, cbSuccess, cbError) {
  http.delete(
    `personal/biography/experience/${experienceID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Get education
export function getPersonalEducation(educationID, cbSuccess, cbError) {
  http.get(
    `personal/biography/education/${educationID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Add education
export function addPersonalEducation(payload, cbSuccess, cbError) {
  http.post(
    'personal/biography/education',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Edit education
export function editPersonalEducation(educationID, payload, cbSuccess, cbError) {
  http.patch(
    `personal/biography/education/${educationID}`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}
// Personal - Remove education
export function removePersonalEducation(educationID, cbSuccess, cbError) {
  http.delete(
    `personal/biography/education/${educationID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-personal/api-personal-biography.js